// A player's item build: two 'skill-loot-list' groups of small loot images.
// Args:
//   @groups - array of arrays of { image, alt }; each inner array becomes one
//             'skill-loot-list' row. (The lineup uses two groups per build.)
<template>
  {{#each @groups as |group|}}
    <div class='skill-loot-list'>
      {{#each group as |item|}}
        <img class='skill-loot-item skill-loot-img small' src={{item.image}} alt={{item.alt}} />
      {{/each}}
    </div>
  {{/each}}
</template>
